export const siteStats = [
  { label: '收录入口', value: '1,286', suffix: '个' },
  { label: '今日更新', value: '48', suffix: '条' },
  { label: '累计访问', value: '326', suffix: '万+' },
  { label: '用户收藏', value: '12.6', suffix: '万' },
];

export const navCategories = [
  {
    id: 'ent',
    name: '娱乐吃瓜',
    icon: 'ri-emotion-laugh-line',
    desc: '综艺、饭圈、艺人日常的集中爆料入口，更新频率最高。',
    count: 268,
  },
  {
    id: 'star',
    name: '明星动态',
    icon: 'ri-star-smile-line',
    desc: '行程、片场、活动路透与前后援会一手消息汇总。',
    count: 194,
  },
  {
    id: 'hot',
    name: '热点追踪',
    icon: 'ri-fire-line',
    desc: '全网热搜与突发热点的入口集合，第一时间跟进。',
    count: 152,
  },
  {
    id: 'film',
    name: '影视八卦',
    icon: 'ri-film-line',
    desc: '剧集、电影、片场幕后与被剪内容的相关入口。',
    count: 176,
  },
  {
    id: 'music',
    name: '音乐现场',
    icon: 'ri-music-2-line',
    desc: '演唱会、音乐节、舞台事故与现场饭拍入口。',
    count: 118,
  },
  {
    id: 'esport',
    name: '电竞游戏',
    icon: 'ri-gamepad-line',
    desc: '赛事战报、选手动态、俱乐部消息与圈内热议入口。',
    count: 143,
  },
  {
    id: 'live',
    name: '直播圈',
    icon: 'ri-live-line',
    desc: '主播动态、直播名场面与直播间节奏入口。',
    count: 129,
  },
  {
    id: 'talk',
    name: '网络热议',
    icon: 'ri-chat-smile-2-line',
    desc: '论坛、社交平台的集中讨论与热评集散入口。',
    count: 106,
  },
];

export const navEntries = [
  {
    id: 'e01',
    name: '瓜田情报站',
    categoryId: 'ent',
    desc: '以整理当日娱乐爆料为主，条目按时间线排列，适合想快速扫一遍全天动态的用户。',
    tags: ['每日更新', '时间线', '新人友好'],
    hot: 9860,
    badge: '热门',
    addr: 'https://go.heiliaodh.com/ent-01',
  },
  {
    id: 'e02',
    name: '榜一吃瓜社',
    categoryId: 'ent',
    desc: '聚焦热榜话题的吃瓜社区，每期会有话题榜单与讨论汇总，评论区活跃度高。',
    tags: ['话题榜', '社区讨论'],
    hot: 8210,
    badge: '官方',
    addr: 'https://go.heiliaodh.com/ent-02',
  },
  {
    id: 'e03',
    name: '深夜瓜铺',
    categoryId: 'ent',
    desc: '晚间集中更新，适合睡前刷一刷，内容以图文长贴为主，节奏偏慢但信息量大。',
    tags: ['夜间更新', '长贴图文'],
    hot: 6740,
    badge: '',
    addr: 'https://go.heiliaodh.com/ent-03',
  },
  {
    id: 'e04',
    name: '星光追踪台',
    categoryId: 'star',
    desc: '追踪艺人公开行程与活动动态，更新及时，附带时间地点等基础信息。',
    tags: ['行程表', '更新快'],
    hot: 7320,
    badge: '新收录',
    addr: 'https://go.heiliaodh.com/star-01',
  },
  {
    id: 'e05',
    name: '片场路透社',
    categoryId: 'star',
    desc: '片场与活动路透聚合入口，内容以短讯与现场图为主，适合追剧组动态。',
    tags: ['路透', '剧组'],
    hot: 5980,
    badge: '',
    addr: 'https://go.heiliaodh.com/star-02',
  },
  {
    id: 'e06',
    name: '热搜档案馆',
    categoryId: 'hot',
    desc: '按日期归档各平台热搜词条，方便回看某个热点的来龙去脉，检索体验好。',
    tags: ['归档', '可检索'],
    hot: 9120,
    badge: '热门',
    addr: 'https://go.heiliaodh.com/hot-01',
  },
  {
    id: 'e07',
    name: '今日爆点',
    categoryId: 'hot',
    desc: '只保留当下最热的几个话题，页面极简，打开就能看到重点，无多余干扰。',
    tags: ['极简', '实时'],
    hot: 8460,
    badge: '官方',
    addr: 'https://go.heiliaodh.com/hot-02',
  },
  {
    id: 'e08',
    name: '剧集显微镜',
    categoryId: 'film',
    desc: '专注剧集细节与幕后花絮，逐集拆解讨论，适合追剧党深入吃透一部作品。',
    tags: ['逐集拆解', '幕后'],
    hot: 5410,
    badge: '',
    addr: 'https://go.heiliaodh.com/film-01',
  },
  {
    id: 'e09',
    name: '影棚小道',
    categoryId: 'film',
    desc: '电影项目立项、换角、补拍等相关消息汇总，条目偏行业向，信息密度高。',
    tags: ['行业向', '项目动态'],
    hot: 4270,
    badge: '新收录',
    addr: 'https://go.heiliaodh.com/film-02',
  },
  {
    id: 'e10',
    name: '音浪观察站',
    categoryId: 'music',
    desc: '演唱会与音乐节的现场信息汇总，含舞台事故、返场曲目与现场饭拍入口。',
    tags: ['现场', '饭拍'],
    hot: 4680,
    badge: '',
    addr: 'https://go.heiliaodh.com/music-01',
  },
  {
    id: 'e11',
    name: '舞台名场面',
    categoryId: 'music',
    desc: '收录各类舞台高光与翻车瞬间的合集入口，按现场年份分类，方便翻找。',
    tags: ['合集', '分类清晰'],
    hot: 3920,
    badge: '',
    addr: 'https://go.heiliaodh.com/music-02',
  },
  {
    id: 'e12',
    name: '赛场速报站',
    categoryId: 'esport',
    desc: '电竞赛事战报与选手动态入口，赛期更新密集，附战况数据与赛后讨论。',
    tags: ['赛事', '数据'],
    hot: 6150,
    badge: '热门',
    addr: 'https://go.heiliaodh.com/esport-01',
  },
  {
    id: 'e13',
    name: '俱乐部内参',
    categoryId: 'esport',
    desc: '聚焦战队人员变动与俱乐部公告，适合关注转会期动向的玩家收藏。',
    tags: ['转会', '公告'],
    hot: 4530,
    badge: '',
    addr: 'https://go.heiliaodh.com/esport-02',
  },
  {
    id: 'e14',
    name: '直播间雷达',
    categoryId: 'live',
    desc: '直播名场面与主播动态聚合入口，按主播分区整理，回看直播切片很方便。',
    tags: ['名场面', '分主播'],
    hot: 5760,
    badge: '新收录',
    addr: 'https://go.heiliaodh.com/live-01',
  },
  {
    id: 'e15',
    name: '热评集散地',
    categoryId: 'talk',
    desc: '把各平台高赞评论整理成辑，看帖子之外还能量顺手看看网友怎么想。',
    tags: ['热评', '精选'],
    hot: 5010,
    badge: '',
    addr: 'https://go.heiliaodh.com/talk-01',
  },
  {
    id: 'e16',
    name: '网民议事厅',
    categoryId: 'talk',
    desc: '网络热议话题的集中讨论入口，条目偏长文，适合想了解事件全貌的读者。',
    tags: ['长文', '全景'],
    hot: 3640,
    badge: '',
    addr: 'https://go.heiliaodh.com/talk-02',
  },
];

export const featuredPicks = [
  {
    id: 'f01',
    title: '本周最稳的三个吃瓜入口',
    summary:
      '从更新速度、条目质量与打开成功率三项指标看，瓜田情报站、热搜档案馆、今日爆点稳定度最高，适合长期收藏。',
    entryId: 'e06',
    tag: '编辑精选',
  },
  {
    id: 'f02',
    title: '追剧党必存的细节挖掘站',
    summary:
      '剧集显微镜逐集拆解，把容易被忽略的伏笔、道具与台词都扒出来，追完剧再看一遍会有新收获。',
    entryId: 'e08',
    tag: '深度推荐',
  },
  {
    id: 'f03',
    title: '赛事期间更新最勤的入口',
    summary: '赛场速报站赛期几乎每小时都有新内容，战报附带数据面板，看比赛结果的同时能顺便看复盘。',
    entryId: 'e12',
    tag: '热点聚焦',
  },
];

export const guideSteps = [
  {
    step: '01',
    icon: 'ri-layout-grid-line',
    title: '先选主题分类',
    desc: '在「主题分类」里点选你关心的方向，入口列表会立即收敛到对应类型，避免大海捞针。',
  },
  {
    step: '02',
    icon: 'ri-search-line',
    title: '再用关键词搜索',
    desc: '在首屏或入口列表的搜索框输入关键词，例如「热搜」「路透」，列表会实时过滤。',
  },
  {
    step: '03',
    icon: 'ri-file-copy-line',
    title: '复制直达地址',
    desc: '点开入口卡片，一键复制直达地址保存到自己的备忘录，下次不用再找。',
  },
  {
    step: '04',
    icon: 'ri-bookmark-3-line',
    title: '收藏本站防走失',
    desc: '把本站加入浏览器收藏夹，即使原入口变动，也能在这里找到最新的可用地址。',
  },
];

export const faqList = [
  {
    q: '黑料导航是什么？',
    a: '黑料导航是一个吃瓜爆料入口的聚合导航页，把分散在各处的娱乐爆料、热点追踪、网红动态等站点入口按主题整理，方便你一次性找到想看的方向。本站只做入口整理与地址收录，不生产内容。',
  },
  {
    q: '怎样快速找到我想要的入口？',
    a: '推荐先点「主题分类」选定大方向，再在搜索框输入关键词二次过滤。也可以直接使用首屏搜索框，输入关键词后页面会自动定位到入口列表并实时筛选结果。',
  },
  {
    q: '为什么有的入口地址打不开？',
    a: '入口站点的域名与可用性由其运营方决定，偶发失效属于正常情况，与本站无关。我们每天会巡检一遍收集到的地址，发现长期无法打开的会及时下架并补充新的可用入口。',
  },
  {
    q: '收录入口需要收费吗？',
    a: '不需要。本站的入口收录与浏览完全免费，也不提供任何付费置顶服务。如果你愿意推荐好用的入口，可以通过页面底部的反馈表提交，人工核验后免费收录。',
  },
  {
    q: '怎样推荐新的入口或者纠正错误？',
    a: '在「入口推荐与纠错反馈」区域填写入口名称、所在分类和地址即可提交。请尽量填写具体信息，描述越清楚，核验和上线速度越快，我们会在确认后更新列表。',
  },
  {
    q: '使用本站需要注意什么？',
    a: '本站仅提供入口整理，不对第三方站点内容负责。请自行判断信息真伪，理性吃瓜，不传播未经证实的内容，也不要泄露他人隐私。遇到可疑站点请及时通过反馈表告知我们。',
  },
];

export const testimonials = [
  {
    name: '阿橘',
    role: '资深吃瓜群众',
    text: '以前收藏夹里塞了一堆链接，过段时间一半都打不开。用黑料导航之后直接按分类找就行，省心太多。',
    avatar: 'https://readdy.ai/api/search-image?query=warm%20orange%20flat%20illustration%20avatar%20of%20a%20friendly%20young%20person%20simple%20geometric%20shapes%20soft%20cream%20background%20minimal%20vector%20portrait&width=200&height=200&seq=avatar-orange-01&orientation=squarish',
  },
  {
    name: '一只咕咕',
    role: '追剧党',
    text: '剧集显微镜就是在这里发现的，逐集拆解真的上头。关键词搜索很准，基本一次就能搜到想要的。',
    avatar: 'https://readdy.ai/api/search-image?query=soft%20green%20flat%20illustration%20avatar%20of%20a%20cheerful%20person%20wearing%20glasses%20simple%20geometric%20shapes%20warm%20beige%20background%20minimal%20vector%20portrait&width=200&height=200&seq=avatar-gugu-02&orientation=squarish',
  },
  {
    name: '深夜不睡',
    role: '电竞观众',
    text: '赛事期间更新是真的勤，战报出来得比我自己去翻快多了，数据面板也做得清楚。',
    avatar: 'https://readdy.ai/api/search-image?query=amber%20gold%20flat%20illustration%20avatar%20of%20an%20enthusiastic%20young%20person%20with%20headphones%20simple%20geometric%20shapes%20light%20cream%20background%20minimal%20vector%20portrait&width=200&height=200&seq=avatar-night-03&orientation=squarish',
  },
];

export const hotKeywords = ['热搜', '路透', '直播回放', '演唱会', '转会', '逐集拆解'];